import * as React from "react";
import type { SVGProps } from "react";
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.273 6.727a1.8 1.8 0 1 1-2.546 2.546 1.8 1.8 0 0 1 2.546-2.546"
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.5 8c0 .198.018.396.042.588l-1.059.828a.6.6 0 0 0-.149.77l.941 1.63a.6.6 0 0 0 .742.255l.948-.38a.61.61 0 0 1 .564.066q.219.146.456.266c.18.092.31.255.339.455l.145 1.009A.6.6 0 0 0 7.06 14h1.878c.297 0 .55-.219.592-.513l.144-1.008c.029-.2.161-.365.342-.456q.235-.118.454-.264a.61.61 0 0 1 .566-.068l.946.38a.6.6 0 0 0 .742-.256l.941-1.628a.6.6 0 0 0-.15-.771l-1.058-.828c.024-.192.042-.39.042-.588s-.018-.396-.042-.588l1.059-.828a.6.6 0 0 0 .149-.77l-.941-1.63a.6.6 0 0 0-.742-.255l-.946.38a.61.61 0 0 1-.566-.068 4 4 0 0 0-.454-.264.61.61 0 0 1-.342-.456l-.144-1.008A.6.6 0 0 0 8.94 2H7.061a.6.6 0 0 0-.592.513l-.145 1.01a.61.61 0 0 1-.34.454q-.236.12-.455.267a.61.61 0 0 1-.565.065l-.947-.38a.6.6 0 0 0-.742.256l-.941 1.628a.6.6 0 0 0 .15.771l1.058.828c-.024.192-.042.39-.042.588"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSettings;
